import { LitElement, html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { style } from "./creator-tile.css";
import "@phosphor-icons/webcomponents/PhArrowCircleUpRight";
import { getAssetUrl } from "helpers/assetHelpers";

@customElement("wow-creator-tile")
export class WowCreatorTile extends LitElement {
  static override styles = [style];

  @property({ type: String })
  handle!: string;

  @property({ type: String })
  mediaUrl!: string;

  @property({ type: String })
  size: "small" | "medium" | "large" = "small";

  @property({ type: Boolean })
  handleAtTop = false;

  @property({ type: Boolean })
  isLink = false;

  private isVideoUrl(url: string): boolean {
    const videoExtensions = [".mp4", ".webm", ".ogg", ".mov", ".avi"];
    return videoExtensions.some((ext) => url.toLowerCase().endsWith(ext));
  }

  private getMediaUrl(): string {
    if (this.mediaUrl.startsWith("http://") || this.mediaUrl.startsWith("https://")) {
      return this.mediaUrl;
    }
    return getAssetUrl(this.mediaUrl);
  }

  renderMedia() {
    const isVideo = this.isVideoUrl(this.mediaUrl);
    const mediaUrl = this.getMediaUrl();

    return html`<div class="image">
      ${isVideo
        ? html`<video src=${mediaUrl} autoplay loop muted playsinline></video>`
        : html`<img src=${mediaUrl} alt="profile picture of ${this.handle}" />`}
    </div>`;
  }

  renderContent() {
    return html`${this.renderMedia()}
      <div class="handle">
        ${this.handle} ${this.isLink ? html` <ph-arrow-circle-up-right size="16"></ph-arrow-circle-up-right>` : nothing}
      </div>`;
  }

  override render() {
    if (this.isLink) {
      return html`
        <a
          href=${window.location.origin + "/" + this.handle}
          class="background ${this.size} ${this.handleAtTop ? "handle-top" : ""}"
        >
          ${this.renderContent()}
        </a>
      `;
    }

    return html`
      <div class="background ${this.size} ${this.handleAtTop ? "handle-top" : ""}">${this.renderContent()}</div>
    `;
  }
}
